import { useGetHttp } from "../../../../hooks/http/http.hook";
import type { IPost } from "../../../../types/models/post.models.types";

interface IResponse{
    posts: IPost[]
}

export function useSearchPostsHttp() {
    return useGetHttp<IResponse>({
        path: "/brand/posts/search",
    });
}